
import { EventEmitter } from "events"

import $ from "jquery"
import StickyNavbarHandler from "app/sticky_navbar_handler/index"
import Notifier from "app/notifier/index"


interface Selector {
  scope:                                string
  country_update_subscription_section:  string
  btn_concierge_scroll:                 string
}

interface InputSelector {
  scope?:                                string
  country_update_subscription_section?:  string
  btn_concierge_scroll?:                 string
}

const default_selector = {
  scope:                                ".page--buildings--country_level_overseas_marketing_projects_page",
  country_update_subscription_section:  ".page-section--overseas-properties-section-country-subscription",
  btn_concierge_scroll:                 ".btn-concierge-scroll",
}


class OverseasMarketingStickyBar extends EventEmitter {
  private selector: Selector

  private $scope: JQuery
  private $country_update_subscription_section: JQuery
  private $btn_concierge_scroll: JQuery

  constructor(selector?: InputSelector){
    super()

    this.selector = Object.assign({}, default_selector, selector)
    this.$scope = $(this.selector.scope)
    this.$country_update_subscription_section = this.$scope.find(this.selector.country_update_subscription_section)
    this.$btn_concierge_scroll = this.$scope.find(this.selector.btn_concierge_scroll)

    this.bind_action()
  }

  private reset_to_concierge_box(){
    StickyNavbarHandler.scrollTo(this.$country_update_subscription_section, {
      duration: 0,
    })
    Notifier.closeAll()
  }

  private bind_action(){
    this.$btn_concierge_scroll.on("click", (e) => {
      e.preventDefault()
      this.reset_to_concierge_box()
    })
    return this
  }
}

const Factory = {
  create(){
    return new OverseasMarketingStickyBar()
  },
}

export {
  Factory,
}
